import { createSlice } from '@reduxjs/toolkit';

import { Http } from '../../Http';

const initialState = {
   token: null,
   isAuthenticated: false,
   user: { email: '', name: '' },
   register: {name: '', email: ''},
   rememberMe: false,
   lastLoggedIn: '',
};

export const superAdminAuth = createSlice({
   name: 'superAdminAuth',
   initialState,

   reducers: {
      logIn: (state, action) => {
         const { payload } = action;

         Http.defaults.headers.common['Authorization'] = `Bearer ${payload.token}`;
         return {
            ...state,
            token: payload.token,
            user: payload.user,
            isAuthenticated: true,
            lastLoggedIn: new Date().toISOString(),
         };
      },

      mE: (state, action) => {
        const { payload } = action;

        return {
           ...state,
           user: payload.user,
        };
      },

      register: (state, action) => {
        const { payload } = action;

        return {
           ...state,
           register: payload.register,
        };
      },

    //   companyUpdateSuper: (state, action) => {
    //     const { payload } = action;

    //     return {
    //        ...state,
    //        companyDetails: payload.company,
    //     };
    //   },

      logOut: (state) => {
         Http.defaults.headers.common['Authorization'] = '';
         return {
            ...state,
            user: initialState.user,
            register: initialState.register,
            token: initialState.token,
            isAuthenticated: initialState.isAuthenticated,
            lastLoggedIn: initialState.lastLoggedIn,
         };
      },

      checkAuth: (state) => {
         if (state.token && state.isAuthenticated) {
            Http.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
         }

         return state;
      },
   },
});

export const { logIn, logOut, checkAuth, mE, register } = superAdminAuth.actions;

export default superAdminAuth.reducer;
